// Cleaned Core UI Themes

export const darkTheme = {
  body: "#121212",
  text: "#E0E0E0",
  highlight: "#b30000",
  dark: "#000000",
  secondaryText: "#C1C1C1",
  imageHighlight: "#b30000",
  compImgHighlight: "#b30000",
  jacketColor: "#b30000",
  headerColor: "#b30000",
};

export const lightTheme = {
  body: "#E0E0E0",
  text: "#121212",
  highlight: "#b30000",
  dark: "#000000",
  secondaryText: "#2e2e2e",
  imageHighlight: "#b30000",
  compImgHighlight: "#b30000",
  jacketColor: "#b30000",
  headerColor: "#b30000",
};

// Your chosen deployment theme
export const chosenTheme = darkTheme;